<template>
   <!-- 选择部门 -->
   <div>
    <el-dialog title="选择部门"
        :visible.sync="isShow"
        :close-on-click-modal="false"
        :show-close="false"
        width="600px">
        <el-row>
            <el-col :span="12">
            <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never">
                <el-input
                class="filter-input"
                placeholder="输入部门"
                v-model="filterText"
                size="small"
                clearable
                >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-tree
                ref="tree"
                :data="departmentData"
                node-key="value"
                :default-expanded-keys="e"
                :default-checked-keys="e"
                :props="departmentProps"
                :check-on-click-node="true"
                @check-change="getDepart"
                :filter-node-method="filterDepart"
                :check-strictly="true"
                >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                    <span>
                    <img class="imgleft" src="../assets/images/zuzhi.png" style="width:14px;height:14px;" alt="">
                    <span v-if="data.is_show === true" style="color: 9D9D9D;">{{ data.label }}</span>
                    <span v-if="data.is_show === false">{{ data.label }}</span><span
                        v-if="node.checked"
                        style="margin-left: 10px;"
                        class="el-icon-check"
                        ></span>
                    </span>
                </span>
                </el-tree>
            </el-card>
            </el-col>
            <el-col :span="12">
            <el-card class="box-card" :body-style="{ height: '460px', overflow: 'auto' }" shadow="never">
                <div style="text-align: left;">已选部门</div>
                <ul class="infinite-list" style="text-align: left;">
                <li v-for="item in department_list" :key="item.id">
                    <img class="organization-img" src="../assets/images/zuzhi.png" style="width:14px;height:14px;" alt="">
                    <span :class="item.label.length <= 20 ? 'wq' : 'wq01'">{{ item.label }}</span>
                    <i style="float: right" class="el-icon-close" @click="empClose(item)"></i>
                </li>
                </ul>
            </el-card>
            </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
            <el-button type="info" plain @click="claseD">取消</el-button>
            <el-button style="width: 72px;" type="primary" :disabled="disabled" @click="$emit('check-user', department_list)">确定</el-button>
        </span>
        </el-dialog>
    </div>
  </template>
  <script>
  import { isAllowRefresh } from '@/utils/util'
  export default {
    props: {
      isShow: {
        type: Boolean,
        required: true,
        default: false
      },
      checkeds: {
        type: Array
      }
    },
    data() {
      return {
        departmentData: [],
        department_list: [],
        e: [],
        departmentProps: {
            children: 'child',
            label: 'label',
            value: 'value',
            disabled: 'is_show'
        },
        filterText: '',
        disabled: false
      }
    },
    mounted() {
        if (this.checkeds) {
            this.checkeds.forEach(k => {
                this.e.push(k.value)
            })
            localStorage.setItem('list', JSON.stringify(this.checkeds))
            this.department_list = this.checkeds
        }
        this.getDepartment()
    },
    watch: {
        filterText(val) {
            this.$refs.tree.filter(val)
        },
        department_list(val) {
            if (val.length > 0) {
                this.disabled = false
            } else {
                this.disabled = true
            }
        }
    },
    methods: {
        getDepartment() {
            this.$api.get('/api/v1/inherit/get-department', {
                user_id: sessionStorage.getItem('user_id')
            }).then(response => {
                let arr = []
                arr = response.data
                this.departmentData = arr || []
            })
        },
        getDepart(value, isCheck) {
            const checkedDepartment = this.department_list
            if (isCheck) {
                checkedDepartment.push({
                    label: value.label,
                    value: value.value
                })
            } else {
                checkedDepartment.forEach((item, i) => {
                    if (item.value === value.value) {
                        checkedDepartment.splice(i, 1)
                    }
                })
            }
            this.checkedDepartment = checkedDepartment
        },
        claseD() {
            const arr = JSON.parse(localStorage.getItem('list'))
            localStorage.removeItem('list')
            this.$emit('check-user', arr)
        },
        // tree过滤
        filterDepart(value, data) {
            if (!value) return true
            return data.label.indexOf(value) !== -1
        },
        empClose(value) {
            this.$refs.tree.setChecked(value.value, false)
        }
    }
  }
  </script>
<style lang="scss" scoped>
    .filter-input {
        margin-bottom: 8px;
        line-height: 34px;
    }
  </style>
